import { GuideThumb, GoogleSearchLink } from './ExerciseGuidePreview';
import { findGuideExercise } from './exerciseGuide';

export default function ActiveProgramOverview({
  program,
  selectedDayName,
  t,
  language,
  onEdit,
  onRemove,
  onCreateNew,
  onOpenExercise,
}) {
  if (!program?.days?.length) return null;

  return (
    <div className="program-overview">
      <div className="program-overview-head">
        <div>
          <p className="section-title section-title--flush">{t.currentProgram}</p>
          {program.confirmedAt && (
            <p className="program-overview-meta">{t.programSince} {program.confirmedAt}</p>
          )}
        </div>
        <div className="program-overview-actions">
          <button type="button" className="btn btn-dark" onClick={onEdit}>{t.editProgram}</button>
          <button type="button" className="btn btn-danger" onClick={onRemove}>{t.removeProgram}</button>
        </div>
      </div>

      <div className="program-day-list">
        {program.days.map((day, i) => (
          <div
            key={`${day.dayName}-${i}`}
            className={`card program-day-card${selectedDayName === day.dayName ? ' is-today' : ''}${day.isRest ? ' is-rest' : ''}`}
          >
            <div className="program-day-card-head">
              <p className="exercise-name">{day.dayName}</p>
              {selectedDayName === day.dayName && <span className="program-day-badge">{t.trainingToday}</span>}
            </div>
            {day.isRest ? (
              <p className="finished-summary">{t.restDayLabel}</p>
            ) : (
              <ul className="program-ex-list">
                {(day.exercises || []).map((ex, j) => {
                  const matched = findGuideExercise(ex.name);
                  return (
                    <li key={`${ex.name}-${j}`}>
                      <div className="program-ex-main">
                        <GuideThumb name={ex.name} onOpen={onOpenExercise} size={40} />
                        {matched ? (
                          <button
                            type="button"
                            className="program-ex-name"
                            onClick={() => onOpenExercise?.(ex.name)}
                          >
                            {ex.name}
                          </button>
                        ) : (
                          <span className="program-ex-name">{ex.name}</span>
                        )}
                        {!matched && ex.name && (
                          <GoogleSearchLink name={ex.name} language={language} className="btn btn-dark program-ex-google">
                            {t.searchGoogle}
                          </GoogleSearchLink>
                        )}
                      </div>
                      {ex.setsReps && <span className="program-ex-sets">{ex.setsReps}</span>}
                    </li>
                  );
                })}
              </ul>
            )}
          </div>
        ))}
      </div>

      <button type="button" className="btn btn-dark" style={{ width: '100%' }} onClick={onCreateNew}>
        {t.replaceProgram}
      </button>
      <p className="guide-credit">{t.guideCredit}</p>
    </div>
  );
}
